import { Box } from '@mui/material'
import SignalFeed from '../components/signals/SignalFeed'

export default function FeedPage({ onUpgrade }) {
  return (
    <Box>
      <SignalFeed onUpgrade={onUpgrade} />
    </Box>
  )
}
